import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/authStore'

// Route modules (now importing objects instead of arrays)
import clubRoutes from './modules/club'
import inventoryRoutes from './modules/inventory'
import orderRoutes from './modules/orders'
import customerRoutes from './modules/customers'
import productRoutes from './modules/products'
import marketingRoutes from './modules/marketing'
import deliveryRoutes from './modules/deliveries'
import nsvRoutes from './modules/nsv'

// Helper function to convert route objects to arrays
function convertRoutesToArray(routeObject) {
	return Object.values(routeObject)
}

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('../views/Home.vue'),
			meta: { title: 'Home' }
		},
		{
			path: '/exito',
			name: 'success',
			component: () => import('../views/Success.vue'),
			meta: { title: 'Éxito' }
		},
		// Convert route objects to arrays and spread them
		...convertRoutesToArray(clubRoutes),
		...convertRoutesToArray(inventoryRoutes),
		...convertRoutesToArray(orderRoutes),
		...convertRoutesToArray(customerRoutes),
		...convertRoutesToArray(productRoutes),
		...convertRoutesToArray(marketingRoutes),
		...convertRoutesToArray(nsvRoutes),
		...convertRoutesToArray(deliveryRoutes)
	]
})

// Global route guard
router.beforeEach(async (to, from, next) => {
	if (to.name === 'home') {
		next()
		return
	}

	const authStore = useAuthStore()

	// Wait for auth initialization if not already done
	if (!authStore.isInitialized) {
		await authStore.checkExistingSession()
	}

	if (to.meta.adminOnly && (!authStore.session || !authStore.isAdmin)) {
		next('/')
		return
	}

	if (!authStore.session || !authStore.userProfile) {
		next(true)
		return
	}

	// Check route access with complete auth state
	const access = authStore.checkRouteAccess(to)

	if (!access) {
		alert('No tienes permisos para acceder a esta página')
		if (from.name) {
			next(false)
		} else {
			next('/')
		}
		return
	}

	next()
})

export default router
